//angular imports
import {
    ChangeDetectionStrategy,
    Component, 
    WritableSignal, 
    signal,
} from '@angular/core';

//local imports
import { PresenterType } from '@shared/components';
import { CategoryNotFoundMessage } from './category-not-found.message';

@PresenterType(
{
    model: CategoryNotFoundMessage
})
@Component({
    selector: 'category-not-found-message-template',
    templateUrl: './category-not-found-message-template.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class CategoryNotFoundMessageTemplateComponent
{
    public data: WritableSignal<CategoryNotFoundMessage>;
    
    constructor() {
        this.data = signal<CategoryNotFoundMessage>(null);
    }
}